import React from 'react';

var NextIcon = function NextIcon() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("circle", {
    cx: "24",
    cy: "24",
    r: "24",
    fill: "#3E3E3E",
    fillOpacity: "0.7",
    transform: "matrix(-1 0 0 1 48 0)"
  }), React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M23.51 35l8.914-10.497L23.504 14m7.982 10.5H13"
  })));
};

export default NextIcon;